module.exports = __webpack_public_path__ + "img/best-goods-title.0708d414.png";